module.exports = "- <ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// /Users/jonshilton/Projects/nick-smith-app/src/app/modules/endorsement/endorsement-author.html
// module id = ../../../../../src/app/modules/endorsement/endorsement-author.html
// module chunks = 0